import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Projects',
  components: {

  },
  props: {

  },
  emits: {
      
  },
})
export default class Projects extends Vue {
    
}
